var axios = require('axios')
const urlTenant = process.env.VUE_APP_version + '/product-tenant'
const urlPaymentMethod = process.env.VUE_APP_version + '/product-payment-fe/payment-methods'

axios.getSocialByClient = function (param, success, callBackError) {
  this.get(urlTenant + '/config', {params: param})
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getPaymentMethod = function (param, success, callBackError) {
  this.get(urlPaymentMethod + '?outlet_code=' + param.outletCode)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status === 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

export default axios
